const routes = [
  {
    path: 'codehl',
    name: 'codehl',
    component: () => import(/* webpackChunkName: "codehl" */ '@/modules/codehl/index.vue')
  },
];

export default routes;